import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { CardWrapper } from '../../Components/Layout/Common/CommonComponents';

interface HeaderToolbarProps {
  leftContent: ReactNode;
  rightContent: ReactNode;
  marginTop?: number;
}

const HeaderToolbar: React.FC<HeaderToolbarProps> = ({
  leftContent,
  rightContent,
  marginTop,
}) => {
  return (
    <CardWrapper
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        mb: 2,
        padding: { xs: 1, sm: 1 },
        mt: { marginTop },
      }}
    >
      <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
        {leftContent}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2,
          width: { xs: '100%', sm: 'auto' },
          justifyContent: { xs: 'center', sm: 'flex-end' },
          marginTop: { xs: 2, sm: 0 },
        }}
      >
        {rightContent}
      </Box>
    </CardWrapper>
  );
};

export default HeaderToolbar;
